import React, { FC, lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import RecoverPassword from "../pages/recover-password";
import UpdateDefaultPassword from "../pages/update-password";
import { FFRoute } from "./feature-flag-route";
import { PrivateRoute } from "./private-route";

const Home = lazy(() => import("../pages/home"));
const GeneralSignIn = lazy(() => import("../pages/sign-in/general"));
const TenantSignIn = lazy(() => import("../pages/sign-in/tenant"));
const ResetPassword = lazy(() => import("../pages/reset-password"));
const Cart = lazy(() => import("../pages/cart"));
const Courses = lazy(() => import("../pages/courses"));

export const Routes: FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <PrivateRoute exact path={availableRoutes.default} component={Home} />
        <Route exact path={availableRoutes.generalSignIn} component={GeneralSignIn} />
        <Route exact path={availableRoutes.tenantSignIn} component={TenantSignIn} />
        <Route exact path={availableRoutes.recoverPassword} component={RecoverPassword} />
        <Route exact path={availableRoutes.resetPassword} component={ResetPassword} />
        <Route exact path={availableRoutes.updateDefaultPassword} component={UpdateDefaultPassword} />
        <PrivateRoute exact path={availableRoutes.cart} component={Cart} />
        <PrivateRoute
          path={availableRoutes.mySearch}
          component={(props: any) => (
            <FFRoute {...props} redirectUrl="/courses/all" allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]} />
          )}
        />
        <PrivateRoute
          path={availableRoutes.newCourses}
          component={(props: any) => {
            return (
              <FFRoute
                {...props}
                redirectUrl="/courses/all?custom=NEW"
                allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
              />
            );
          }}
        />
        <PrivateRoute
          path={availableRoutes.recentlyPurchasedCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?custom=RECENTLY_PURCHASED"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.learningPathsCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?filter.format=learningpath"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.primeCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?subscription=PRIME"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.primeExclusiveCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?subscription=PRIME_EXCLUSIVE"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.selectCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?subscription=SELECT"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.selectExclusiveCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?subscription=SELECT_EXCLUSIVE"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute
          path={availableRoutes.essentialsCourses}
          component={(props: any) => (
            <FFRoute
              {...props}
              redirectUrl="/courses/all?subscription=ESSENTIALS"
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          )}
        />
        <PrivateRoute path={availableRoutes.courses} component={Courses} />

        <Route
          path="*"
          component={(props: any) => {
            window.location.assign(props.location.pathname);
            return null;
          }}
        />
      </Switch>
    </Suspense>
  );
};

export const availableRoutes = {
  default: "/",
  generalSignIn: "/signin",
  tenantSignIn: "/signin/:tenant_ref_key",
  recoverPassword: "/forgotPassword",
  resetPassword: "/resetPassword", // changing this will need to change it on the recover password email
  updateDefaultPassword: "/updateDefaultPassword",
  cart: "/cart",
  mySearch: "/mySearch",
  courses: "/courses/:tab",
  newCourses: "/courses/new",
  recentlyPurchasedCourses: "/courses/recentlypurchased",
  myCourses: "/courses/mycourses",
  learningPathsCourses: "/courses/learningpaths",
  providerCourses: "/courses/provider",
  primeCourses: "/courses/primecourses",
  primeExclusiveCourses: "/courses/primeexclusivecourses",
  selectCourses: "/courses/selectcourses",
  selectExclusiveCourses: "/courses/selectexclusivecourses",
  essentialsCourses: "/courses/essentialscourses"
};

export type TenantSignInParams = {
  tenant_ref_key: string;
};
